import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import AboutUsPage from "../pages/about/page";
import ContactUsPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/local-moving",
    element: <ServicesPage />,
  },
  {
    path: "/residential-moving",
    element: <ServicesPage />,
  },
  {
    path: "/commercial-moving",
    element: <ServicesPage />,
  },
  {
    path: "/apartment-moving",
    element: <ServicesPage />,
  },
  {
    path: "/storage-in-and-out",
    element: <ServicesPage />,
  },
  {
    path: "/packing-service",
    element: <ServicesPage />,
  },
  {
    path: "/packers-and-movers",
    element: <ServicesPage />,
  },
  {
    path: "/labor-only-moving",
    element: <ServicesPage />,
  },
  {
    path: "/about-us",
    element: <AboutUsPage />,
  },
  {
    path: "/contact-us",
    element: <ContactUsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;